var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CButton',{class:{ 'default': _vm.color === '' },attrs:{"color":_vm.color,"variant":"outline"},on:{"click":_vm.openSupportModal}},[_vm._t("default",[_vm._v("Update Information")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }